import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Signin from '../Auth/Signin';
import ForgotPassword from '../Auth/ForgotPassword';
import VerifyOtp from '../Auth/VerifyOtp';
import SetPassword from '../Auth/SetPassword';
import Admin from '../features/Dashboard/Admin';
import NotFound from '../CommonPages/NotFound';
import ProtectedRoute from '../Auth/ProtectedRoute';
import Loader from '../Components/Loader/Loader';



function AllRoutes() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path='/' element={<Signin />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/verify-otp' element={<VerifyOtp />} />
        <Route path='/reset-password' element={<SetPassword />} />
        <Route path='/loader' element={<Loader />} />
        {/* Protected Routes */}
        <Route path="/dashboard" element={<ProtectedRoute><Admin /></ProtectedRoute>} />


        {/* Catch-all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default AllRoutes;
